/**
 * Texte zu einem Lauf aus GET lauf/, gemeinsam für „Letzte Läufe“, Protokoll und die Seite je Ablauf
 * (Konzept Steuerungen und Schnittstellen 9.2 bis 9.4). Farbregel 9.1: Rot nur für Fehler, Bernstein nur für
 * „braucht Aufmerksamkeit“, der Normalfall ohne Farbe.
 */

/**
 * Status in der Tabellenzeile. klein: der Schlüssel beginnt gross wie im Filter, hier steht er mit kleinem
 * Anfang (kleinAnfang).
 */
const ERGEBNIS = {
  WARTET: { text: "wartet", schluessel: "global.waiting" },
  LAEUFT: { text: "läuft", schluessel: "global.running", klein: true },
  ZU_PRUEFEN: { text: "zu prüfen", schluessel: "global.tocheck", klasse: "text-bernstein" },
  WIRD_ANGEWENDET: { text: "wird angewendet", schluessel: "global.beingapplied" },
  ERFOLGREICH: { text: "erfolgreich", schluessel: "global.successful", klein: true },
  MIT_FEHLERN: { text: "Mit Fehlern", schluessel: "global.witherrors", klasse: "text-bernstein" },
  FEHLGESCHLAGEN: { text: "Fehlgeschlagen", schluessel: "global.notification_failed", klasse: "text-rot" },
  ABGEBROCHEN: { text: "abgebrochen", schluessel: "global.cancelled", klein: true },
  UEBERHOLT: { text: "überholt", schluessel: "global.superseded", klein: true },
};

/** Arten der Abläufe in der Reihenfolge des Boards (9.2) */
export const ARTEN = [
  {
    key: "schnittstelle",
    text: "Schnittstelle",
    schluessel: "global.interface",
    mehrzahl: "Schnittstellen",
    mehrzahlSchluessel: "global.interfaces",
  },
  {
    key: "versendung",
    text: "Versendung",
    schluessel: "global.sending",
    mehrzahl: "Versendungen",
    mehrzahlSchluessel: "global.sendings",
  },
  {
    key: "prozess",
    text: "Prozess",
    schluessel: "global.processsingular",
    mehrzahl: "Prozesse",
    mehrzahlSchluessel: "global.processes",
  },
  {
    key: "systemjob",
    text: "Systemjob",
    schluessel: "global.systemjob",
    mehrzahl: "Systemjobs",
    mehrzahlSchluessel: "global.systemjobs",
  },
];

export function artText(lauf, t) {
  return uebersetzt(t, ARTEN.find((a) => a.key === lauf.art) || { text: lauf.art });
}

/** Status, die im Filter Ergebnis „Läuft“ heissen (9.4) */
export const STATUS_LAEUFT = "WARTET,LAEUFT,WIRD_ANGEWENDET";

/** Status, die in den Filtern „Mit Fehlern“ heissen (9.2) */
export const STATUS_MIT_FEHLERN = "MIT_FEHLERN,FEHLGESCHLAGEN";

/** Filter Ergebnis mit dem Parameter status für GET lauf/ (9.4), für Protokoll und Seite je Ablauf */
export const ERGEBNIS_FILTER = [
  { key: "alle", text: "Alle", schluessel: "global.all", status: "" },
  { key: "erfolgreich", text: "Erfolgreich", schluessel: "global.successful", status: "ERFOLGREICH" },
  { key: "mitFehlern", text: "Mit Fehlern", schluessel: "global.witherrors", status: "MIT_FEHLERN" },
  { key: "fehlgeschlagen", text: "Fehlgeschlagen", schluessel: "global.notification_failed", status: "FEHLGESCHLAGEN" },
  { key: "abgebrochen", text: "Abgebrochen", schluessel: "global.cancelled", status: "ABGEBROCHEN" },
  { key: "laeuft", text: "Läuft", schluessel: "global.running", status: STATUS_LAEUFT },
];

/** Filter Auslöser mit den Parametern ausloeser und test; Testläufe zählen nur unter Testlauf */
export const AUSLOESER_FILTER = [
  { key: "alle", text: "Alle", schluessel: "global.all", parameter: {} },
  {
    key: "automatisch",
    text: "Automatisch",
    schluessel: "global.automatic",
    parameter: { ausloeser: "zeitplan", test: "n" },
  },
  { key: "hand", text: "Von Hand", schluessel: "global.manual", parameter: { ausloeser: "knopf", test: "n" } },
  { key: "test", text: "Testlauf", schluessel: "global.testrun", parameter: { test: "j" } },
];

/**
 * Erster Buchstabe klein, der Rest bleibt: „Von Hand“ wird „von Hand“, nicht „von hand“. Nur für Schlüssel,
 * deren Text mit einem Verb oder Adjektiv beginnt, nie mit einem Nomen.
 */
export function kleinAnfang(text) {
  return text ? text.charAt(0).toLocaleLowerCase() + text.slice(1) : text;
}

/**
 * Text eines Eintrags in der Sprache des Benutzers: mit Sprachschlüssel (schluessel, mehrzahlSchluessel, …) über
 * t, sonst der deutsche Text; klein: true macht den ersten Buchstaben des übersetzten Texts klein. t ist die
 * Übersetzung der Komponente, (s) => this.$t(s); $t allein geht nicht, weil vue-i18n dafür this braucht.
 */
export function uebersetzt(t, eintrag, feld = "text") {
  const schluessel = eintrag[feld === "text" ? "schluessel" : feld + "Schluessel"];
  if (!schluessel || !t) return eintrag[feld];
  return eintrag.klein ? kleinAnfang(t(schluessel)) : t(schluessel);
}

/** Text eines Schlüssels über t, ohne t der deutsche Text */
function text(t, schluessel, deutsch) {
  return t ? t(schluessel) : deutsch;
}

export function ergebnisText(lauf, t) {
  return uebersetzt(t, ERGEBNIS[lauf.status] || { text: lauf.status });
}

export function ergebnisKlasse(lauf) {
  return (ERGEBNIS[lauf.status] || {}).klasse || "";
}

/**
 * Die Zusammenfassung schreibt der Ablauf. Fehlt sie, weil der Lauf abgebrochen, durch einen Neustart
 * unterbrochen oder unerwartet fehlgeschlagen ist, steht an ihrer Stelle die Meldung des Runners, grau
 * (ohne Personendaten wie die Zusammenfassung).
 */
export function zusammenfassungText(lauf) {
  return lauf.zusammenfassung || lauf.meldung || "";
}

export function zusammenfassungIstMeldung(lauf) {
  return !lauf.zusammenfassung && !!lauf.meldung;
}

/** Ablauf und Laufart mit ihren Bezeichnungen aus der Anmeldung */
export function ablaufText(lauf) {
  return `${lauf.ablaufBezeichnung || lauf.ablauf}, ${lauf.laufartBezeichnung || lauf.laufart}`;
}

/** Auslöser wie auf dem Board: automatisch, der Name bei einem Lauf von Hand, Testlauf mit Namen */
export function ausloeserText(lauf, t) {
  if (lauf.test) {
    const testlauf = text(t, "global.testrun", "Testlauf");
    return lauf.gestartetVonName ? `${testlauf}, ${lauf.gestartetVonName}` : testlauf;
  }
  if (lauf.ausloeser === "zeitplan") return t ? kleinAnfang(t("global.automatic")) : "automatisch";
  if (lauf.ausloeser === "ereignis") return text(t, "global.eventtrigger", "Ereignis");
  return lauf.gestartetVonName || (t ? kleinAnfang(t("global.manual")) : "von Hand");
}

/** Dauer wie in der Lauf-Ansicht: „12 s“ oder „3 Min. 12 s“, leer, solange der Lauf nicht begonnen hat */
export function dauerText(lauf, t) {
  const s = lauf.dauerSekunden;
  if (s === null || s === undefined) return "";
  const min = Math.floor(s / 60);
  return min > 0 ? `${min} ${text(t, "global.minabbr", "Min.")} ${s % 60} s` : `${s} s`;
}
